import store from '../../../store';
import VPagination from '../../VPagination.vue';
import ProductHelpersMixin from '../../../mixins/ProductHelpersMixin';

export default {
    components: { VPagination },

    mixins: [
        ProductHelpersMixin,
    ],

    data() {
        return {
            fetchingWishlist: false,
            products: { data: [] },
            currentPage: 1,
            windowWidth: window.innerWidth,
        };
    },

    computed: {
        wishlistIsEmpty() {
            return this.products.data.length === 0;
        },

        totalPage() {
            return Math.ceil(this.products.total / 20);
        },

        gridColumns() {
            if (this.windowWidth >= 1600) {
                return 4;
            } else if (this.windowWidth >= 1240) {
                return 3;
            } else if (this.windowWidth >= 670) {
                return 2;
            } else {
                return 1;
            }
        },
    },

    watch: {
        // Watch for changes to window width and update the property
        windowWidth(newWidth) {
            this.$nextTick(() => {
                this.$forceUpdate();
            });
        },
    },

    created() {
        this.fetchWishlist();
    },

    mounted() {
        window.addEventListener('resize', this.updateWindowWidth);
    },

    destroyed() {
        window.removeEventListener('resize', this.updateWindowWidth);
    },

    methods: {
        fetchWishlist() {
            this.fetchingWishlist = true;

            $.ajax({
                method: 'GET',
                url: route('wishlist.products.index', {
                    page: this.currentPage,
                }),
            }).then((products) => {
                this.products = products;
            }).catch((xhr) => {
              this.$errorNotify(xhr.responseJSON.message)
            }).always(() => {
                this.fetchingWishlist = false;
            });
        },

        remove(product) {
            this.products.data.splice(this.products.data.indexOf(product), 1);
            this.products.total--;

            store.removeFromWishlist(product.id);
        },

        updateWindowWidth() {
            // Update window width and trigger watcher
            this.windowWidth = window.innerWidth;
        },
    },
};
